// src/components/PrivateRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children, requiredRoles = [] }) => {
    const { user } = useSelector(state => state.auth);
    const location = useLocation();

    // Check if user is logged in
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check if email verification is required (except for verify-email route)
    if (!user.is_verified && !location.pathname.includes('/verify-email')) {
        return <Navigate to="/verify-email" state={{ from: location }} replace />;
    }

    // Check if user has required role (if any specified)
    if (requiredRoles.length > 0 && !requiredRoles.includes(user.role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default PrivateRoute;